<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    @close="closeHandler"
  >
    <el-form v-if="elementformulaEditable" inline>
      <el-form-item label="Statistical Account">
        <el-select ref="statisticalAccountRef" v-model="form.elementNo" style="width: 210px;" :filterable="true" :clearable="true" placeholder="Please select">
          <el-option
            v-for="(item,index) in statisticalAccountCollection"
            :key="index"
            :label="accountTitleLabelFun(item)"
            :value="item.accountTitle"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Operator">
        <el-select v-model="form.operateMode" style="width: 70px;">
          <el-option label="+" :value="1" />
          <el-option label="-" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="Account">
        <el-select ref="accountTitleRef" v-model="form.accountTitle" style="width: 210px;" :filterable="true" :clearable="true" placeholder="Please select">
          <el-option
            v-for="(item,index) in accountTitleCollection"
            :key="index"
            :label="accountTitleLabelFun(item)"
            :value="item.accountTitle"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addAccountTitleBtnClickHandler">Add</el-button>
      </el-form-item>
    </el-form>
    <div>
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:300px;padding-left:2px"
      />
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="footer.gridOptions"
        :column-defs="columnDefs2"
        :row-data="footer.rowData"
        :auto-fit-content="false"
        class="accounting-document-grid accounting-document-grid-footer"
        style="width:100%;padding-left:2px"
      />
    </div>
    <div slot="footer" style="padding-right:350px">
      <el-button v-if="elementformulaEditable" type="primary" @click="saveHander">Confirm</el-button>
      <el-button @click="closeHandler">Cancel</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as statementElementDescriptionApi from '@/api/financeManage/statementElementDescription'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'

export default {
  name: 'ElementFormulaNewDialog',
  props: {
    visible: { type: Boolean, required: true },
    atbDictionary: { type: Object, required: true },
    accountSet: { type: Object, default: null },
    elementformulaEditable: { type: Boolean, required: true },
    statementDescriptionUuid: { type: String, required: true },
    statementDescription: { type: Object, default: null }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      innerVisible: false,
      form: {
        elementNo: '',
        accountTitle: '',
        operateMode: 1
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: true,
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        }
      },
      rowData: [],
      footer: {
        gridOptions: {
          alignedGrids: [],
          headerHeight: 0,
          suppressContextMenu: true,
          suppressRowSelection: true,
          suppressRowClickSelection: true,
          rowHeight: 30,
          defaultColDef: {
            suppressMenu: true,
            suppressMovable: true,
            headerClass: 'text-center'
          }
        },
        rowData: [
          {
            accountTitle: 'Total',
            ending: '',
            beginningYear: ''
          }
        ]
      }
    }
  },
  computed: {
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    // 统计科目
    statisticalAccountCollection() {
      if (!this.accountTitleCollection || !this.statementDescription.statementElementDescription) return []
      const list = []
      for (const element of this.statementDescription.statementElementDescription) {
        const accountTitle = this.accountTitleCollection.find(title => title.accountTitle === element.elementNo)
        if (accountTitle) list.push(accountTitle)
      }
      return list
    },
    title() {
      return 'New statistical items'
    },
    columnDefs() {
      return [
        { headerName: 'Statistical Account', field: 'elementNo', width: 200,
          valueFormatter: params => {
            return params.data.elementNo + ' ' + params.data.name
          }
        },
        {
          headerName: 'Operator',
          field: 'operateMode',
          width: 100,
          valueFormatter: params => {
            return this.operateModeFun(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Account', field: 'accountTitle', width: 200,
          valueFormatter: params => {
            return this.accountTitleFun(params.value)
          }
        },
        {
          headerName: this.endingHeadName(), field: 'ending', width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.beginningYearHeadName(), field: 'beginningYear', width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('delete')
            const del = this.$t('CargoMsg.Cargo_Delete')
            return `<a onclick="${methodPath}('${params.rowIndex}')" style="color: red;text-decoration: underline;">${del}</a>`
          },
          cellStyle: { textAlign: 'center' }
        }
      ]
    },
    columnDefs2() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'accountTitle',
          width: 500
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'),
          field: 'ending',
          width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'),
          field: 'beginningYear',
          width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80
        }
      ]
    },
    dialogWidth() {
      return this.elementformulaEditable ? '865px' : '785px'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        // 加载列表数据
        this.loadData()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('delete', function(data) {
      self.deleteClickHandler(data)
    })
  },
  methods: {
    async loadData() {
      if (!this.statementDescriptionUuid) return
      await this.fillItem()
      this.total()
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + ' ' + accountTitle.accountTitleName : ''
    },
    accountTitleFun(accountTitle) {
      return this.accountTitleLabelFun(this.getAccountTitle(accountTitle))
    },
    operateModeFun(value) {
      return value ? '+' : '-'
    },
    async addAccountTitleBtnClickHandler() {
      if (!this.form.elementNo || !this.form.accountTitle) return
      if (this.rowData.find(elementFormula => elementFormula.elementNo === this.form.elementNo && elementFormula.accountTitle === this.form.accountTitle) !== undefined) {
        this.$message.warning(this.form.elementNo + '-' + this.form.accountTitle + ' already existed')
        return
      }
      this.rowData.push(await this.creatItem(this.form.elementNo, this.form.operateMode, this.form.accountTitle))
      this.clearForm()
      this.total()
    },
    async creatItem(elementNo, operateMode, accountTitle) {
      const ac = this.getAccountTitle(elementNo)
      const result = {}
      result.elementNo = elementNo
      result.name = ac.accountTitleName
      result.operateMode = operateMode
      result.accountTitle = accountTitle
      const atb = this.getAccountTitleBalance(accountTitle)
      if (atb) {
        if (this.statementDescription.statementName.indexOf('ProfitLoss') !== -1) {
          result.beginningYear = atb.currentMonthTotalAmount
          result.ending = atb.currentYearTotalAmount
        } else {
          result.beginningYear = atb.beginningBalance
          result.ending = atb.currentMonthBalanceAmount
        }
      } else {
        result.beginningYear = 0
        result.ending = 0
      }
      return result
    },
    clearForm(bClose) {
      if (bClose) this.form.elementNo = ''
      this.form.operateMode = 1
      this.form.accountTitle = ''
    },
    getAccountTitle(accountTitle) {
      if (!this.accountTitleCollection || !accountTitle) {
        return null
      }
      return this.accountTitleCollection.find(title => title.accountTitle === accountTitle)
    },
    getAccountTitleBalance(accountTitle) {
      return this.atbDictionary[accountTitle]
    },
    saveHander() {
      for (const element of this.statementDescription.statementElementDescription) {
        const elementFormulas = []
        for (const row of this.rowData) {
          if (row.elementNo === element.elementNo) {
            row.elementDescriptionUuid = element.uuid
            elementFormulas.push(row)
          }
        }
        element.elementFormula = elementFormulas
        element.calculatedItem = elementFormulas.length > 0 ? 1 : 0
      }
      if (!this.statementDescription.statementColumnDescription) this.statementDescription.statementColumnDescription = []
      const loading = getLoading()
      statementElementDescriptionApi.saveList(this.statementDescription).then(resp => {
        this.statementDescription.statementElementDescription = []
        this.statementDescription.statementElementDescription = resp.data
        this.closeHandler()
      }).finally(() => loading.close())
    },
    deleteClickHandler(rowIndex) {
      this.rowData.splice(rowIndex, 1)
    },
    closeHandler() {
      this.clearForm(true)
      this.$emit('close')
    },
    async fillItem() {
      this.rowData = []
      for (const element of this.statementDescription.statementElementDescription) {
        for (const formula of element.elementFormula) {
          const row = {}
          row.elementNo = element.elementNo
          row.name = element.name
          row.operateMode = formula.operateMode
          row.accountTitle = formula.accountTitle
          this.rowData.push(row)
        }
      }
      for (const formula of this.rowData) {
        const atb = this.getAccountTitleBalance(formula.accountTitle)
        if (atb) {
          formula.beginningYear = atb.beginningBalance
          formula.ending = atb.currentMonthBalanceAmount
        } else {
          formula.beginningYear = 0
          formula.ending = 0
        }
      }
    },
    // 合计
    total() {
      let ending = 0
      let beginningYear = 0
      for (const row of this.rowData) {
        ending += Number(row.ending)
        beginningYear += Number(row.beginningYear)
      }
      this.footer.rowData[0].ending = ending
      this.footer.rowData[0].beginningYear = beginningYear
      this.footer.gridOptions.api.refreshCells({ force: true })
    },
    endingHeadName() {
      if (this.statementDescriptionUuid && this.statementDescription.statementName.indexOf('ProfitLoss') !== -1) {
        return this.$t('CargoMsg.Cargo_CurrentYearAccumulatedAmount')
      } else {
        return this.$t('CargoMsg.Cargo_PeriodEndAmount')
      }
    },
    beginningYearHeadName() {
      if (this.statementDescriptionUuid && this.statementDescription.statementName.indexOf('ProfitLoss') !== -1) {
        return this.$t('CargoMsg.Cargo_AmountOfCurrentMonth')
      } else {
        return this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear')
      }
    }
  }
}
</script>

<style lang="scss">
.accounting-document-grid{
  .ag-cell-inline-editing {
    height: 100%!important;
  }
  .ag-header-cell{
    &.text-center {
      text-align: center;
      .ag-header-cell-text{
        display: inline;
        width: 100%;
        height: 100%;
        line-height: 64px;
      }
    }
    &::after {
      height: 48px;
    }
  }
  .ag-cell {
    border-right: 1px solid #d9dcde;
  }
  .ag-cell-inline-editing {
    height: 30px;
  }
  &-footer {
    height: 34px;
    .ag-theme-balham {
      min-height: 34px!important;
    }
  }
}

</style>
